import { FC } from 'react';
import { useRouter } from 'next/navigation';
import { Badge, IconSvg } from '@/components';
import classNames from 'classnames';

import style from './ProductBadge.module.scss';

const ProductBadge: FC<BadgeProps> = ({
  link,
  showIcon,
  label,
  iconName,
  type,
  className,
}) => {
  const router = useRouter();

  const handleClick = (e, link) => {
    e.preventDefault();
    e.stopPropagation();
    router.push(link);
  };

  return (
    <Badge
      className={classNames(
        style.product_badge,
        className,
        type && style[`product_badge__${type}`],
      )}
      isCustom
      title={label}
    >
      {showIcon && iconName && <IconSvg name={iconName} />}
      {link && <button onClick={e => handleClick(e, link)}>{label}</button>}
      {!link && <span>{label}</span>}
    </Badge>
  );
};

interface BadgeProps {
  link?: string;
  showIcon?: boolean;
  iconName?: string;
  label?: string;
  type: 'discount' | 'seller' | 'specials' | 'bogo' | 'warning' | 'info';
  className?: string;
}

export default ProductBadge;
